import * as React from 'react';

export const Icon = (props: { name: string, color?: string, class?: string }) => (
  <svg className={`x-icon ${props.class ? props.class : ''}`} color={props.color}>
    <use xlinkHref={`#${props.name}`} />
  </svg>
);